"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8940],{

/***/ 33514:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dx": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.Dx; },
/* harmony export */   "Hq": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.Hq; },
/* harmony export */   "ZP": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.Ob; },
/* harmony export */   "h4": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.h4; },
/* harmony export */   "uT": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.uT; },
/* harmony export */   "xv": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.xv; }
/* harmony export */ });
/* harmony import */ var _FeatureBox__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13379);

_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .FeatureBox.displayName */ .Ob.displayName = "FeatureBoxBase";
_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .Body.displayName */ .uT.displayName = "FeatureBox.Body";
_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .Header.displayName */ .h4.displayName = "FeatureBox.Header";
_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .Text.displayName */ .xv.displayName = "FeatureBox.Text";
_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .Title.displayName */ .Dx.displayName = "FeatureBox.Title";


/***/ }),

/***/ 49183:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "uT": function() { return /* reexport */ Body; },
  "W2": function() { return /* reexport */ Container; },
  "h4": function() { return /* reexport */ CarouselCard_Header; },
  "xv": function() { return /* reexport */ CarouselCard_Text; },
  "Dx": function() { return /* reexport */ CarouselCard_Title; },
  "ZP": function() { return /* reexport */ CarouselCard; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(13102);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/withDesignTokens.tsx
var withDesignTokens = __webpack_require__(72300);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../libs/matcha/components/Tabs/Tab/index.ts + 5 modules
var Tab = __webpack_require__(39610);
// EXTERNAL MODULE: ../../libs/matcha/components/FeatureBox/index.ts
var FeatureBox = __webpack_require__(33514);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/CarouselCard/CarouselCard.views.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}



var Text = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(FeatureBox/* Text */.xv,  true ? {
  target: "e7ykuc46"
} : 0)(function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("sm");
}, "{row-gap:22px;}" + ( true ? "" : 0));
var Container = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(FeatureBox/* default */.ZP,  true ? {
  target: "e7ykuc45"
} : 0)(function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("md");
}, "{row-gap:22px;}" + ( true ? "" : 0));
var Title = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(FeatureBox/* Title */.Dx,  true ? {
  target: "e7ykuc44"
} : 0)( true ? "" : 0);
var Body = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(FeatureBox/* Body */.uT,  true ? {
  target: "e7ykuc43"
} : 0)( true ? "" : 0);
var PanelWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e7ykuc42"
} : 0)("position:relative;padding:24px;width:269px;height:100%;", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.up("sm");
}, "{width:360px;}", function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.up("lg");
}, "{width:auto;height:auto;padding:24px 32px;}&::before{content:'';display:block;position:absolute;top:0;left:0;z-index:-2;width:100%;height:100%;border-radius:5px;", function (_ref5) {
  var theme = _ref5.theme;
  return theme.breakpoints.down("md");
}, "{background-color:", function (_ref6) {
  var backgroundColor = _ref6.backgroundColor;
  return backgroundColor;
}, ";}}" + ( true ? "" : 0));
var TabBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Tab/* Base */.XY,  true ? {
  target: "e7ykuc41"
} : 0)( true ? {
  name: "1lvg79j",
  styles: "height:100%;border-radius:5px"
} : 0);
var Header = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(FeatureBox/* Header */.h4,  true ? {
  target: "e7ykuc40"
} : 0)("color:", function (_ref7) {
  var color = _ref7.color;
  return color;
}, ";" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/CarouselCard/CarouselCard.tsx


var _excluded = ["children", "tokens"],
    _excluded2 = ["children", "tokens"],
    _excluded3 = ["children", "tokens"],
    _excluded4 = ["children", "tokens"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}









var BaseCarouselCard = function BaseCarouselCard(_ref) {
  var children = _ref.children,
      value = _ref.value,
      active = _ref.active,
      tokens = _ref.tokens;
  var appearance = (0,AppearanceContext/* useAppearance */.M)();
  return (0,emotion_react_browser_esm/* createElement */.az)(TabBase, _objectSpread(_objectSpread({}, tokens.wrapper), {}, {
    value: value,
    tint: "boysenberry",
    key: value
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: active ? "dark" : appearance,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Panel, {
      tokens: tokens.panel,
      children: children
    })
  }));
};

var CarouselCard = (0,withDesignTokens/* default */.Z)(BaseCarouselCard, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      wrapper: {},
      panel: {
        backgroundColor: (0,polished_esm/* transparentize */.DZ)(0.9, theme.palette.neutrals.white[100])
      }
    };
  },
  dark: function dark(theme) {
    return {
      wrapper: {},
      panel: {
        backgroundColor: (0,polished_esm/* transparentize */.DZ)(0.9, theme.palette.neutrals.white[100])
      }
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      wrapper: {},
      panel: {
        backgroundColor: theme.palette.neutrals.white[100]
      }
    };
  }
});

var Panel = function Panel(_ref2) {
  var children = _ref2.children,
      tokens = _ref2.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref2, _excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PanelWrapper, _objectSpread(_objectSpread(_objectSpread({}, tokens), rest), {}, {
    children: react.Children.map(children, function (child) {
      if ( /*#__PURE__*/(0,react.isValidElement)(child)) {
        return /*#__PURE__*/(0,react.cloneElement)(child, _objectSpread(_objectSpread({}, child.props), rest));
      }
    })
  }));
};

var BaseHeader = function BaseHeader(_ref3) {
  var children = _ref3.children,
      tokens = _ref3.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref3, _excluded2);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Header, _objectSpread(_objectSpread(_objectSpread({}, tokens), rest), {}, {
    children: children
  }));
};

var CarouselCard_Header = (0,withDesignTokens/* default */.Z)(BaseHeader, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      color: theme.palette.brand.darkAcai[700]
    };
  },
  dark: function dark(theme) {
    return {
      color: theme.palette.neutrals.white[100]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      color: theme.palette.twilio.gray[100]
    };
  }
});

var BaseText = function BaseText(_ref4) {
  var children = _ref4.children,
      tokens = _ref4.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref4, _excluded3);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text, _objectSpread(_objectSpread({
    tokens: tokens
  }, rest), {}, {
    children: children
  }));
};

var CarouselCard_Text = (0,withDesignTokens/* default */.Z)(BaseText, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      color: theme.palette.brand.darkAcai[500]
    };
  },
  dark: function dark(theme) {
    return {
      color: (0,polished_esm/* transparentize */.DZ)(0.3, theme.palette.neutrals.white[100])
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      color: theme.palette.twilio.gray[100]
    };
  }
});

var BaseTitle = function BaseTitle(_ref5) {
  var children = _ref5.children,
      tokens = _ref5.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref5, _excluded4);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title, _objectSpread(_objectSpread({
    tokens: tokens
  }, rest), {}, {
    children: children
  }));
};

var CarouselCard_Title = (0,withDesignTokens/* default */.Z)(BaseTitle, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      color: theme.palette.twilio.gray[100]
    };
  },
  dark: function dark(theme) {
    return {
      color: theme.palette.neutrals.white[100]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      color: theme.palette.twilio.gray[100]
    };
  }
});
/* harmony default export */ var CarouselCard_CarouselCard = ((/* unused pure expression or super */ null && (CarouselCard)));
;// CONCATENATED MODULE: ../../libs/matcha/recipes/CarouselCard/index.ts


CarouselCard.displayName = "CarouselCardBase";
Container.displayName = "CarouselCard.Container";
CarouselCard_Header.displayName = "CarouselCard.Header";
Body.displayName = "CarouselCard.Body";
CarouselCard_Title.displayName = "CarouselCard.Title";
CarouselCard_Text.displayName = "CarouselCard.Text";


/***/ }),

/***/ 86926:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "CK": function() { return /* reexport */ Copy; },
  "pU": function() { return /* reexport */ Media; },
  "t": function() { return /* reexport */ Picture; },
  "ZP": function() { return /* reexport */ SectionTabbed_SectionTabbed; }
});

// UNUSED EXPORTS: Controls, Image

// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/render/dom/motion-minimal.mjs + 21 modules
var motion_minimal = __webpack_require__(48714);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/SectionTabbed/SectionTabbed.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}




var _ref7 =  true ? {
  name: "1lxqoxl",
  styles: "grid-template-columns:1fr;grid-template-areas:'controls' 'copy' 'contents'"
} : 0;

var _ref8 =  true ? {
  name: "f4egrz",
  styles: "grid-template-columns:1fr;grid-template-areas:'copy' 'controls' 'contents'"
} : 0;

var getMobileGridTemplateAreas = function getMobileGridTemplateAreas(controls) {
  if (controls === "bottom") {
    return _ref8;
  }

  if (controls === "top") {
    return _ref7;
  }
};

var _ref5 =  true ? {
  name: "1lxqoxl",
  styles: "grid-template-columns:1fr;grid-template-areas:'controls' 'copy' 'contents'"
} : 0;

var _ref6 =  true ? {
  name: "f4egrz",
  styles: "grid-template-columns:1fr;grid-template-areas:'copy' 'controls' 'contents'"
} : 0;

var getTabletGridTemplateAreas = function getTabletGridTemplateAreas(controls) {
  if (controls === "bottom") {
    return _ref6;
  }

  if (controls === "top") {
    return _ref5;
  }
};

var _ref =  true ? {
  name: "o2cv5g",
  styles: "grid-template-columns:1fr 1fr;grid-template-areas:'controls controls' 'contents copy'"
} : 0;

var _ref2 =  true ? {
  name: "ip597j",
  styles: "grid-template-columns:1fr 1fr;grid-template-areas:'contents copy' 'controls .'"
} : 0;

var _ref3 =  true ? {
  name: "1fpj14x",
  styles: "grid-template-columns:1fr 1fr;grid-template-areas:'controls controls' 'copy contents'"
} : 0;

var _ref4 =  true ? {
  name: "74m15c",
  styles: "grid-template-columns:1fr 1fr;grid-template-areas:'copy contents' '. controls'"
} : 0;

var getGridTemplateAreas = function getGridTemplateAreas(reverse, controls) {
  if (controls === "bottom" && !reverse) {
    return _ref4;
  }

  if (controls === "top" && !reverse) {
    return _ref3;
  }

  if (controls === "bottom" && reverse) {
    return _ref2;
  }

  if (controls === "top" && reverse) {
    return _ref;
  }
};

var SectionTabbed = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(motion_minimal.m.div,  true ? {
  target: "e832pd44"
} : 0)("position:relative;z-index:0;display:grid;row-gap:0;margin:auto;", function (_ref9) {
  var _ref9$mode = _ref9.mode,
      mode = _ref9$mode === void 0 ? "vertical" : _ref9$mode,
      theme = _ref9.theme;
  return mode === "vertical" &&
  /*#__PURE__*/

  /*#__PURE__*/
  (0,emotion_react_browser_esm/* css */.iv)("grid-template-areas:'copy' 'contents';", theme.breakpoints.up("lg"), "{gap:48px;grid-auto-flow:column;grid-template-columns:minmax(368px, 384px) auto;grid-template-areas:'copy contents';}", theme.breakpoints.up("xl"), "{gap:96px;justify-content:center;}" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0);
}, " ", function (_ref10) {
  var mode = _ref10.mode,
      theme = _ref10.theme,
      _ref10$controls = _ref10.controls,
      controls = _ref10$controls === void 0 ? "bottom" : _ref10$controls,
      _ref10$reverse = _ref10.reverse,
      reverse = _ref10$reverse === void 0 ? false : _ref10$reverse;
  return mode === "horizontal" &&
  /*#__PURE__*/

  /*#__PURE__*/
  (0,emotion_react_browser_esm/* css */.iv)("max-width:1440px;column-gap:80px;align-items:start;", Controls, ",", Media, "{justify-self:center;}", getMobileGridTemplateAreas(controls), ";row-gap:40px;", theme.breakpoints.up("md"), "{", getTabletGridTemplateAreas(controls), ";}", theme.breakpoints.up("lg"), "{", getGridTemplateAreas(reverse, controls), " align-items:center;}" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0);
}, ";" + ( true ? "" : 0));
var Controls = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e832pd43"
} : 0)( true ? {
  name: "17k349u",
  styles: "grid-area:controls"
} : 0);
var Copy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(motion_minimal.m.div,  true ? {
  target: "e832pd42"
} : 0)( true ? {
  name: "1ep2nob",
  styles: "grid-area:copy;overflow-x:auto"
} : 0);
var Media = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(motion_minimal.m.div,  true ? {
  target: "e832pd41"
} : 0)( true ? {
  name: "18kx31g",
  styles: "width:100%;grid-area:contents;max-width:800px;display:grid;justify-content:center;will-change:contents"
} : 0);
var Picture = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e832pd40"
} : 0)( true ? {
  name: "9th5i",
  styles: "margin:0 auto"
} : 0);
/* harmony default export */ var SectionTabbed_SectionTabbed = (SectionTabbed);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/SectionTabbed/__stories__/Image.tsx


function Image_EMOTION_STRINGIFIED_CSS_ERROR_() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var Image = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("img",  true ? {
  target: "e16bywro0"
} : 0)( true ? {
  name: "fmbosm",
  styles: "display:block;height:auto;max-width:100%;margin:0 auto"
} : 0);
/* harmony default export */ var _stories_Image = ((/* unused pure expression or super */ null && (Image)));
;// CONCATENATED MODULE: ../../libs/matcha/recipes/SectionTabbed/index.ts

SectionTabbed.displayName = "SectionTabbedBase";
Copy.displayName = "SectionTabbed.Copy";
Controls.displayName = "SectionTabbed.Controls";
Media.displayName = "SectionTabbed.Media";
Picture.displayName = "SectionTabbed.Picture";



/***/ })

}]);